<div class="wrap">
  <div class="card">
  <h1>{{ 'previsions.ajustementManuel.title' | translate }}</h1>
  <div class="card-header">
    <div class="title">
      <div class="queue-selector">
        <label class="queue-label">{{ 'previsions.ajustementManuel.queueLabel' | translate }}</label>
        <select [value]="selectedQueueId()" (change)="selectedQueueId.set($any($event.target).value)">
          <option *ngFor="let queue of session.queues()" [value]="queue.id">
            {{ queue.name }}
          </option>
        </select>
      </div>
      <!-- TODO:SHOW_SITUATION — décommenter pour réafficher le sélecteur Situation + bouton Gérer
      <div class="period-selector">
        <div style="display: flex; align-items: center; gap: 8px;">
          <label class="period-label">SITUATION</label>
          <div class="info-tooltip">
            <span class="info-icon">?</span>
            <div class="info-tooltip-content">
              Les situations permettent d'adapter vos prévisions selon les périodes spécifiques (ex: vacances scolaires, fin d'année, soldes...). La situation 'Par défaut' s'applique en dehors de ces périodes.
            </div>
          </div>
        </div>
        <div style="display: flex; gap: 12px; align-items: flex-end;">
          <select [(ngModel)]="selectedContextId" [disabled]="loadingContexts()">
            <option *ngFor="let context of contexts()" [value]="context.id">
              {{ context.name }}
            </option>
          </select>
          <button type="button" class="btn btn-primary" style="height: 44px; padding: 0 14px; display: flex; align-items: center; gap: 8px;" (click)="openContextModal()" [disabled]="loadingContexts()">
            <svg *ngIf="!loadingContexts()" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
            <span *ngIf="loadingContexts()">⏳</span>
            Gérer
          </button>
        </div>
      </div>
      TODO:SHOW_SITUATION -->
    </div>
    <div class="day-selector">
      <button
        *ngFor="let day of days"
        class="day-btn"
        [class.active]="selectedDay() === day.value"
        (click)="selectDay(day.value)">
        {{ day.labelKey | translate }}
      </button>
    </div>
    <div class="action-buttons">
      <button type="button" class="secondary" *ngIf="hasChanges()" (click)="cancelChanges()">
        {{ 'previsions.ajustementManuel.actions.cancel' | translate }}
      </button>
      <button type="button" class="primary" (click)="saveConfig()" [disabled]="saving() || isEstablishmentClosed() || !isWizardConfigured()">
        {{ (saving() ? 'previsions.ajustementManuel.actions.saving' : 'previsions.ajustementManuel.actions.save') | translate }}
      </button>
    </div>
  </div>

  <div class="card-body">
    <div class="graph-container">
      <app-forecast-graph
        #forecastGraph
        [queueId]="selectedQueueId() ?? undefined"
        [loadBaseline]="true"
        [displayBaseline]="showBaseline"
        [loadHistoricalScans]="true"
        [showHistoricalScans]="showHistorical"
        [externalSensorFlowPoints]="sensorFlowPoints"
        [showSensorFlow]="showSensorOnGraph"
        [bare]="true"
        [lowThreshold]="lowTh"
        [highThreshold]="highTh"
        [dayOfWeek]="selectedDay()"
        [selectedPeriod]="selectedContextId ?? undefined"
        [contextName]="getSelectedContextName()"
        [queueName]="getSelectedQueueName()"
        [barColorLow]="'#513e9b'"
        [barColorMid]="'#f59e0b'"
        [barColorHigh]="'#ef4444'">
      </app-forecast-graph>

      <!-- Message wizard non configuré -->
      <div class="wizard-warning" *ngIf="!isWizardConfigured() && !isEstablishmentClosed()">
        <div class="warning-icon">🔒</div>
        <div class="warning-content">
          <div class="warning-title">{{ 'previsions.ajustementManuel.wizardWarning.title' | translate }}</div>
          <div class="warning-subtitle">{{ 'previsions.ajustementManuel.wizardWarning.subtitle' | translate }}</div>
        </div>
      </div>

      <div class="graph-overlay" *ngIf="!isEstablishmentClosed() && isWizardConfigured()">
        <div class="bar-controls">
          <ng-container *ngFor="let slot of forecastGraph?.timeSlotData || []; let i = index">
            <div class="bar-handle"
                 [class.closed]="!slot.open"
                 [style.left.%]="getBarPosition(i)"
                 [style.bottom]="getBarHeightPx(slot.minutes)"
                 *ngIf="slot.open"
                 (mousedown)="startDrag(i, $event)">
              <div class="bar-tip">
                <span class="bar-value">{{ slot.minutes }}</span>
                <div class="adjustment-lines">
                  <div class="line"></div>
                  <div class="line"></div>
                  <div class="line"></div>
                </div>
                <div class="grip-dots">
                  <div class="grip-line"></div>
                  <div class="grip-line"></div>
                  <div class="grip-line"></div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- Légendes -->
    <div class="baseline-legend" style="margin-top: 8px; font-size: 12px; color: #FF2B98; font-weight: 600; display: flex; align-items: center; gap: 8px;">
      <label class="toggle-switch" style="margin: 0;">
        <input type="checkbox" [(ngModel)]="showBaseline" (change)="toggleBaseline()">
        <span class="toggle-slider"></span>
      </label>
      <span style="display: inline-block; width: 20px; height: 3px; background: repeating-linear-gradient(to right, #FF2B98 0, #FF2B98 8px, transparent 8px, transparent 12px); vertical-align: middle; margin-right: 6px;"></span>
      {{ 'previsions.ajustementManuel.legend.aiPrediction' | translate }}
    </div>
    <div class="baseline-legend" style="margin-top: 4px; font-size: 12px; color: #3b82f6; font-weight: 600; display: flex; align-items: center; gap: 8px;">
      <label class="toggle-switch" style="margin: 0;">
        <input type="checkbox" [(ngModel)]="showHistorical" (change)="toggleHistorical()">
          <span class="toggle-slider"></span>
      </label>
      <span style="display: inline-block; width: 20px; height: 3px; background: repeating-linear-gradient(to right, #3b82f6 0, #3b82f6 8px, transparent 8px, transparent 12px); vertical-align: middle; margin-right: 6px;"></span>
      {{ 'previsions.ajustementManuel.legend.historicalScans' | translate }}
    </div>
    <div class="baseline-legend" [class.legend-disabled]="!sensorDataAvailable()" style="margin-top: 4px; font-size: 12px; color: #22c55e; font-weight: 600; display: flex; align-items: center; gap: 8px;">
      <label class="toggle-switch" style="margin: 0;">
        <input type="checkbox" [(ngModel)]="showSensorOnGraph" [disabled]="!sensorDataAvailable()">
        <span class="toggle-slider"></span>
      </label>
      <span style="display: inline-block; width: 20px; height: 3px; background: repeating-linear-gradient(to right, #22c55e 0, #22c55e 8px, transparent 8px, transparent 12px); vertical-align: middle; margin-right: 6px;"></span>
      {{ 'previsions.ajustementManuel.legend.sensorFlow' | translate }}
    </div>

    <div class="help-text" *ngIf="isWizardConfigured()">
      <p>{{ 'previsions.ajustementManuel.helpText.instructions' | translate }}</p>
      <button type="button" class="secondary" (click)="resetToBaseline()">
        {{ 'previsions.ajustementManuel.actions.resetToBaseline' | translate }}
      </button>
    </div>

    <!-- Présence moyenne capteur -->
    <app-sensor-presence-chart
      [hidden]="true"
      [establishmentId]="session.selectedId()"
      [dayOfWeek]="selectedDay()"
      (dataAvailable)="sensorDataAvailable.set($event)"
      (dataPoints)="sensorFlowPoints = $event">
    </app-sensor-presence-chart>
  </div>

  </div>
</div>

<!-- Popup de confirmation sauvegarde -->
<div *ngIf="showConfirmModal()" class="modal-overlay" (click)="cancelSave()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <h3>{{ 'previsions.ajustementManuel.confirmModal.title' | translate }}</h3>
    <p>{{ 'previsions.ajustementManuel.confirmModal.message' | translate }}</p>
    <div class="modal-actions">
      <button type="button" class="secondary" (click)="cancelSave()">{{ 'previsions.ajustementManuel.actions.cancel' | translate }}</button>
      <button type="button" class="primary" (click)="confirmSave()" [disabled]="saving()">
        {{ (saving() ? 'previsions.ajustementManuel.actions.saving' : 'previsions.ajustementManuel.actions.confirm') | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Popup de confirmation réinitialisation -->
<div *ngIf="showResetConfirmModal()" class="modal-overlay" (click)="cancelReset()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <h3>{{ 'previsions.ajustementManuel.actions.resetToBaseline' | translate }}</h3>
    <p>{{ 'previsions.ajustementManuel.resetModal.message' | translate }}</p>
    <div class="modal-actions">
      <button type="button" class="secondary" (click)="cancelReset()">{{ 'previsions.ajustementManuel.actions.cancel' | translate }}</button>
      <button type="button" class="primary" (click)="confirmReset()">
        {{ 'previsions.ajustementManuel.actions.reset' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Modale liste des contextes -->
<app-context-modal
  *ngIf="showContextModal()"
  [contexts]="contexts()"
  [queueId]="selectedQueueId() ?? ''"
  (close)="closeContextModal()"
  (contextModified)="onContextModified()">
</app-context-modal>
